type UploadFn = () => Promise<void>

const registry = new Map<string, UploadFn>()

export const registerPendingUpload = (formName: string, fieldName: string, fn: UploadFn) =>
  registry.set(`${formName}:${fieldName}`, fn)

export const clearPendingUpload = (formName: string, fieldName: string) =>
  registry.delete(`${formName}:${fieldName}`)

export const runPendingUploads = async (formName: string): Promise<void> => {
  const prefix = `${formName}:`
  const matching = [...registry.entries()].filter(([key]) => key.startsWith(prefix))

  matching.forEach(([key]) => registry.delete(key))

  await Promise.all(matching.map(([, fn]) => fn()))
}
